module.exports = __webpack_public_path__ + "files/255e7a725280c6beddc8f635fdfe3ffe.png";